import {FC, lazy} from 'react';
import {BusinessCardDataType} from 'api/types/LeadForm';
import {LeadFormBusinessCard} from '@target-web/leadads-form-view';
import {onCopyToClickboard} from 'utils/bridge';
import {AppProps} from './types';
import { VIEW } from 'utils/types';
import useBusinessCardsAnalytics from 'utils/hooks/useBusinessCardsAnalytics';

const HlsPlayer = lazy(() => import(/* webpackChunkName: "hls" */ './HlsPlayer/HlcPlayer'));

type AppBusinessCardProps = AppProps & {
    formData: BusinessCardDataType;
    formDataHash: string | null;
};
const AppBusinessCard: FC<AppBusinessCardProps> = ({formData}) => {

    const {clickToCallAnalyticEvent, clickToExternalLinkAnalyticEvent} = useBusinessCardsAnalytics();

    return (
        <LeadFormBusinessCard
            clickToCall={clickToCallAnalyticEvent}
            clickToExternalLink={clickToExternalLinkAnalyticEvent}
            copyToClickboard={onCopyToClickboard}
            layout={VIEW.overlay}
            businessCard={formData}
            HlsComponent={HlsPlayer}
        />
    );
};

export default AppBusinessCard;
